module.exports = __webpack_public_path__ + "img/soundcloud-512.20265604.png";